import AdminComponent from "@/components/dashboard/AdminComponent";

import OrderPartSearch from "@/views/search/OrderPartSearch";
import OrderPartCreate from "@/views/create/OrderPartCreate";
import OrderPartUpdate from "@/views/update/OrderPartUpdate";

export default {
    path: "/order-part",
    meta: {auth: true},
    component: AdminComponent,
    children: [
        {path: "search", name: "order-part-search", component: OrderPartSearch},
        {path: "create", name: "order-part-create", component: OrderPartCreate},
        {path: "edit/:id", name: "order-part-edit", component: OrderPartUpdate, props: true},
    ]
}
